import Perfume from 'perfume.js'
import { cutlassEvent } from '@polleverywhere/cutlass'

function triggerEvent (app, name, value) {
  cutlassEvent(app.el, `web-vitals:${name}`, value)
}

/**
 * Real user monitoring with Perfume.js
 */
export default (app) => {
  /* eslint-disable no-new */
  new Perfume({
    resourceTiming: false,
    elementTiming: true,
    analyticsTracker: (options) => {
      const {
        metricName,
        data
      } = options

      switch (metricName) {
        case 'navigationTiming':
          if (data && data.timeToFirstByte) {
            triggerEvent(app, 'navigation_timing', data)
          }
          break
        case 'networkInformation':
          if (data && data.effectiveType) {
            triggerEvent(app, 'network_information', data)
          }
          break
        case 'storageEstimate':
          triggerEvent(app, 'storage_estimate', data)
          break
        case 'fp':
          triggerEvent(app, 'first_paint', { duration: data })
          break
        case 'fcp':
          triggerEvent(app, 'first_contentful_paint', { duration: data })
          break
        case 'fid':
          triggerEvent(app, 'first_input_delay', { duration: data })
          break
        case 'lcp':
          triggerEvent(app, 'largest_contentful_paint', { duration: data })
          break
        case 'lcpFinal':
          triggerEvent(app, 'largest_contentful_paint_final', { duration: data })
          break
        case 'cls':
          triggerEvent(app, 'cumulative_layout_shift', { value: data })
          break
        case 'clsFinal':
          triggerEvent(app, 'cumulative_layout_shift_final', { value: data })
          break
        case 'tbt':
          triggerEvent(app, 'total_blocking_time', { duration: data })
          break
        case 'tbt10S':
          triggerEvent(app, 'total_blocking_time_10s', { duration: data })
          break
      }
    }
  })
}
